import { useMemo } from '@wordpress/element';
import { contextConnect, ContextSystemProvider } from '../../context';
import { Elevation } from '../../elevation';
import { View } from '../../view';
import styles from '../style.module.scss';
import { useCard } from './hook';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UnconnectedCard(props, forwardedRef) {
  const {
    children,
    elevation,
    isBorderless,
    isRounded,
    size,
    ...otherProps
  } = useCard(props);
  const contextProviderValue = useMemo(() => {
    const contextProps = {
      size,
      isBorderless
    };
    return {
      CardBody: contextProps,
      CardHeader: contextProps,
      CardFooter: contextProps
    };
  }, [isBorderless, size]);
  return /*#__PURE__*/_jsx(ContextSystemProvider, {
    value: contextProviderValue,
    children: /*#__PURE__*/_jsxs(View, {
      ...otherProps,
      ref: forwardedRef,
      children: [/*#__PURE__*/_jsx(View, {
        className: styles.content,
        children: children
      }), /*#__PURE__*/_jsx(Elevation, {
        isInteractive: false,
        value: elevation ? 1 : 0
      }), /*#__PURE__*/_jsx(Elevation, {
        isInteractive: false,
        value: elevation
      })]
    })
  });
}

/**
 * `Card` provides a flexible and extensible content container.
 * `Card` also provides a convenient set of sub-components such as `CardBody`,
 * `CardHeader`, `CardFooter`, and more.
 *
 * ```jsx
 * import {
 *   Card,
 *   CardHeader,
 *   CardBody,
 *   CardFooter,
 *   __experimentalText as Text,
 *   __experimentalHeading as Heading,
 * } from `@wordpress/components`;
 *
 * function Example() {
 *   return (
 *     <Card>
 *       <CardHeader>
 *         <Heading level={ 4 }>Card Title</Heading>
 *       </CardHeader>
 *       <CardBody>
 *         <Text>Card Content</Text>
 *       </CardBody>
 *       <CardFooter>
 *         <Text>Card Footer</Text>
 *       </CardFooter>
 *     </Card>
 *   );
 * }
 * ```
 */
export const Card = contextConnect(UnconnectedCard, 'Card');
export default Card;